import { assocPath } from 'ramda'
import * as t from './types'

export const { name } = t

export const initialState = {
  badwordscore: {
    isFetching: false,
    isRefreshing: false,
    data: {
      factor: 0,
      foundWords: [],
      language: 0,
      score: 0,
      str: '',
      wouldBeBlocked: false,
    },
  },
  experiments: {
    isLoadingReroll: false,
  },
  error: null,
  isLoading: false,
  isSaving: false,
}

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case t.REFRESH_BADWORDSCORE:
      return {
        ...state,
        badwordscore: {
          ...initialState.badwordscore,
          isRefreshing: true,
        },
        error: undefined,
      }

    case t.REFRESH_BADWORDSCORE_SUCCESS: {
      const { ...data } = payload
      return {
        ...state,
        badwordscore: {
          ...initialState.badwordscore,
          data: {
            ...data,
            foundWords: data.foundWords ? data.foundWords.data : [],
          },
        },
      }
    }

    case t.REFRESH_BADWORDSCORE_ERROR:
      return {
        ...state,
        badwordscore: {
          ...initialState.badwordscore,
          isRefreshing: false,
        },
        error: payload,
      }

    case t.REROLL_EXPERIMENTS:
      return assocPath(['experiments', 'isLoadingReroll'], true, state)

    case t.REROLL_EXPERIMENTS_ERROR:
    case t.REROLL_EXPERIMENTS_SUCCESS:
      return assocPath(['experiments', 'isLoadingReroll'], false, state)

    default:
      return state
  }
}
